import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { get, getVerticalComponents } from 'ctm-util-functions';

class CustomFieldGroupLayout extends Component {

    constructor(props) {
        super(props);
        this.variants = {};
        const verticalComponents = getVerticalComponents();
        if (verticalComponents) {
            this.variants = Object.assign(this.variants, verticalComponents);
        }
    }

    /**
     * Just renders what is provided if an invalid variant is not passed.
     * @returns {Node} Children only
     */
    renderChildrenOnly = () => {
        const { children } = this.props;
        return (
            <>
                {children}
            </>
        );
    };

    render = () => {
        const { schema } = this.props;
        if (!schema) {
            throw Error('This component must have a schema prop');
        }
        const schemaVariant = get(schema, 'field.variant');
        if (!schemaVariant) {
            return this.renderChildrenOnly();
        }
        const componentVariant = this.variants[schemaVariant];
        if (!componentVariant) {
            throw Error(`Variant from schema could not be found in verticalComponents: ${schemaVariant}`);
        }
        return React.createElement(componentVariant, this.props);
    };

}

CustomFieldGroupLayout.propTypes = {
    schema: PropTypes.object.isRequired, // The schema for this form element
    children: PropTypes.object
};

export { CustomFieldGroupLayout };
